import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    message: '',
}

const errorSlice = createSlice({
    name: "errorSlice",
    initialState,
    reducers: {
      setError: (state, action) => {state.message = action.payload},
    }
  });
  
  
  export const { setError } =  errorSlice.actions;
  export default errorSlice.reducer